import { APP_MODULES } from "@/data_source/constants";
import { CAPABILITIES } from "@/utils/auth/capabilities";
import {
  assetCapabilityGuardValidationBuilder,
  capabilitiesGuardValidationBuilder
} from "@/utils/auth/guards_builder";

import type { RouterValidator } from "./router_guard";

/**
 * Single source of truth for the read routes an Assets row action opens.
 * The route guards and the table/card actions evaluate the same validator, so
 * an action is only offered when its destination would render for the user.
 */
export const assetDetailAccessValidator: RouterValidator =
  assetCapabilityGuardValidationBuilder(CAPABILITIES.ASSETS.VIEW);

export const assetPhotoGalleryAccessValidator: RouterValidator =
  capabilitiesGuardValidationBuilder(
    [CAPABILITIES.ASSETS.VIEW, CAPABILITIES.PHOTO_MANAGER.VIEW],
    [APP_MODULES.ASSETS_MODULE, APP_MODULES.PICTURE_MODULE],
    ["operational"],
    {
      renderAccessDenied: true,
      accessDeniedMessage: "You do not have permission to access this page.",
      requireAll: true,
      requireAllModules: true
    }
  );

type RouterValidateArgs = Parameters<RouterValidator["validate"]>;

export type AssetRowActionAccessContext = {
  user: RouterValidateArgs[0];
  workspace: RouterValidateArgs[2];
  workspaceContext: RouterValidateArgs[3];
};

export type AssetRowActionAccess = {
  canViewAssetDetails: boolean;
  canOpenAssetMedia: boolean;
};

export function resolveAssetRowActionAccess({
  user,
  workspace,
  workspaceContext
}: AssetRowActionAccessContext): AssetRowActionAccess {
  return {
    canViewAssetDetails: assetDetailAccessValidator.validate(
      user,
      undefined,
      workspace,
      workspaceContext
    ),
    canOpenAssetMedia: assetPhotoGalleryAccessValidator.validate(
      user,
      undefined,
      workspace,
      workspaceContext
    )
  };
}
